import React from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import images from "../../utilities/images/images";
import { url_37 } from "../../custom_utilities/api_services";
import { formatNotificationDisplayDate } from "../../custom_utilities/notificationDateUtils";
import "./NotificationListPanel.scss";

export default function NotificationListPanel({
  active = false,
  embeddedInMySpace = false,
  heading = "Notification",
}) {
  const authToken = useSelector((state) => state.auth.authToken);
  const tokenType = useSelector((state) => state.auth.tokenType);

  const [notificationsList, setNotificationsList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const fetchNotifications = React.useCallback(async () => {
    if (!String(authToken || "").trim() || !tokenType) return;
    setLoading(true);
    try {
      const response = await axios.get(url_37, {
        headers: { Authorization: `${tokenType} ${authToken}` },
      });
      if (response?.data?.status === 200) {
        setNotificationsList(Array.isArray(response.data.data) ? response.data.data : []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [authToken, tokenType]);

  React.useEffect(() => {
    if (active) {
      fetchNotifications();
    }
  }, [active, fetchNotifications]);

  return (
    <div
      className={`notification_list_panel${
        embeddedInMySpace ? " notification_list_panel--my-space" : ""
      }`}
    >
      <div className="notification_dataBox">
        <div className="heading">
          <h3>{heading}</h3>
        </div>
        <div className="notification_list_wrpr" aria-busy={loading}>
          {loading ? (
            <div className="notification_list_panel__loader" role="status" aria-label="Loading notifications">
              <ClipLoader color="#C61C26" size={32} />
            </div>
          ) : notificationsList.length ? (
            notificationsList.map((element, index) => (
              <div key={index} className="notification_list">
                <div className="notification_list_icon" aria-hidden="true">
                  <img src={images.motion_logo_new} alt="" />
                </div>
                <div className="notification_list_body">
                  <div className="ntf_title">
                    <h6>{element?.notification_title}</h6>
                    <span>{formatNotificationDisplayDate(element)}</span>
                  </div>
                  <div className="ntf_desc">
                    <p>{element?.notification_description}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="notDataFound">
              <img src={images?.M2Notification} alt="" />
              <h6>No Notification</h6>
              <p>It seems like you don't have any notification right now!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
